import React from 'react'
import { keyframes } from '@emotion/react'
import { Box } from '@maui/elements'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(359deg); }
`

export const Spinner = props => {
  return (
    <Box
      display="inline-flex"
      flexDirection="row"
      alignItems="center"
      fontWeight="bold"
      _before={{
        content: '""',
        display: 'block',
        marginX: 'spaceGapSmall',
        borderColor: 'transparent white white',
        borderRadius: '50%',
        borderStyle: 'solid',
        animation: `${spin} 2s linear infinite`,
        height: '1em',
        width: '1em',
        borderWidth: '0.2em',
      }}
      {...props}
    />
  )
}
